import { Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ProgramRole } from '@app/shared/enums';
import {
  ComparisonSelectorsApiModel,
  EmployeeSuccessReportFiltersApiModel,
  EmployeeSuccessReportApiModel,
  TraineePerformanceReportFiltersApiModel,
  TraineePerformanceReportRequestApiModel,
  TraineePerformanceReportApiModel,
  TrainerPerformanceReportFiltersApiModel,
  TrainerPerformanceReportRequestApiModel,
  TrainerPerformanceReportApiModel
} from '@app/api/api-models';
import { PrintApiModel } from '@app/api/api-models/reports/PrintApiModel';
import { EmployeeSuccessReportFilterSelectorsApiModel } from '@app/api/api-models/reports/trainee-success/EmployeeSuccessReportFilterSelectorsApiModel';
import { HttpClientService } from '@app/api/api-services/http-client.service';

@Injectable()
export class PpReportsService {
  public apiUrl = 'pe-reports';

  constructor(private http: HttpClientService, private domSanitizer: DomSanitizer) {}

  public getComparisonSelectors(role?: ProgramRole): Observable<ComparisonSelectorsApiModel> {
    return this.http.get<ComparisonSelectorsApiModel>(`${this.apiUrl}/comparison-selectors?role=${role}`);
  }

  public getEmployeeSuccessReport(
    filters: EmployeeSuccessReportFiltersApiModel
  ): Observable<EmployeeSuccessReportApiModel> {
    return this.http.post<EmployeeSuccessReportApiModel>(`${this.apiUrl}/employee-success/report`, filters.serialize());
  }

  public getEmployeeSuccessPrint(model: PrintApiModel<EmployeeSuccessReportFiltersApiModel>): Observable<Blob> {
    model.Requests = model.Requests.map((x) => x.serialize());

    return this.http.post(`${this.apiUrl}/employee-success/pdf`, model, { responseType: 'blob' });
  }

  public getEmployeeSuccessXlsx(model: PrintApiModel<EmployeeSuccessReportFiltersApiModel>): Observable<Blob> {
    model.Requests = model.Requests.map((x) => x.serialize());

    return this.http.post(`${this.apiUrl}/employee-success/xlsx-all`, model, { responseType: 'blob' });
  }

  public getEmployeeSuccessReportSelectors(): Observable<EmployeeSuccessReportFilterSelectorsApiModel> {
    return this.http
      .get<EmployeeSuccessReportFilterSelectorsApiModel>(`${this.apiUrl}/employee-success/filters`)
      .pipe(
        map((response) => new EmployeeSuccessReportFilterSelectorsApiModel().deserialize(response, this.domSanitizer))
      );
  }

  public getTraineePerformanceFilterData(): Observable<TraineePerformanceReportFiltersApiModel> {
    return this.http.get<TraineePerformanceReportFiltersApiModel>(`${this.apiUrl}/employee-performance/filters`);
  }

  public getTraineePerformanceReport(
    filters: TraineePerformanceReportRequestApiModel
  ): Observable<TraineePerformanceReportApiModel> {
    return this.http.post<TraineePerformanceReportApiModel>(`${this.apiUrl}/employee-performance/report`, filters);
  }

  public getTraineePerformancePrint(model: PrintApiModel<TraineePerformanceReportRequestApiModel>): Observable<Blob> {
    return this.http.post(`${this.apiUrl}/employee-performance/pdf`, model, { responseType: 'blob' });
  }

  public getTraineePerformanceXlsx(filters: TraineePerformanceReportRequestApiModel): Observable<Blob> {
    return this.http.post(`${this.apiUrl}/employee-performance/xlsx`, filters, { responseType: 'blob' });
  }

  public getSupervisorPerformanceFilterData(): Observable<TrainerPerformanceReportFiltersApiModel> {
    return this.http.get<TrainerPerformanceReportFiltersApiModel>(`${this.apiUrl}/supervisor-performance/filters`);
  }

  public getSupervisorPerformanceReport(
    filters: TrainerPerformanceReportRequestApiModel
  ): Observable<TrainerPerformanceReportApiModel> {
    return this.http.post<TrainerPerformanceReportApiModel>(`${this.apiUrl}/supervisor-performance/report`, filters);
  }

  public getSupervisorPerformancePrint(
    model: PrintApiModel<TrainerPerformanceReportRequestApiModel>
  ): Observable<Blob> {
    return this.http.post(`${this.apiUrl}/supervisor-performance/pdf`, model, { responseType: 'blob' });
  }

  public getSupervisorPerformanceXlsx(filters: TrainerPerformanceReportRequestApiModel): Observable<Blob> {
    return this.http.post(`${this.apiUrl}/supervisor-performance/xlsx`, filters, { responseType: 'blob' });
  }
}
